module.exports = __webpack_public_path__ + "img/nuza.6362d6c6.svg";